<template>
  <div class="testprofile">
    <el-steps style="margin-top: 40px; width: 90%; margin-left: 5%" :active="active" align-center finish-status="success"
      process-status="finish">
      <el-step :title="item.title" v-for="(item, index) in projectDetail.process" :key="index" class="toptitle"
        space="10%" :status="item.step_status" @click.native="jumpToProcess(index, item)"></el-step>
    </el-steps>

    <!-- 1.考试文件 -->
    <div v-for="(item, index) in projectDetail.process" :key="item.name">
      <!-- <div class="warm-tip">提示信息：开始时间2022年1月2日～2022年1月20日，当前步骤{{index}}</div> -->
      <!-- {{ active }},{{ index }} -->
      <kswj v-if="item.name === 'kswj'" :process_index="index" :process="item" :current="projectDetail.step"
        v-show="step_name === item.name">
      </kswj>
      <!--3. 资料登记 -->
      <zldj v-if="item.name === 'zldj'" :process_index="index" :process="item" :current="projectDetail.step"
        v-show="step_name === item.name" />
      <!-- 2.考生承诺 -->
      <kscn v-if="item.name === 'kscn'" :process_index="index" :process="item" :current="projectDetail.step"
        v-show="step_name === item.name">
      </kscn>

      <!-- 4.报考信息-录聘 -->
      <bkxx v-if="item.name === 'bkxx'" :process_index="index" :process="item" :current="projectDetail.step"
        v-show="step_name === item.name">
      </bkxx>

      <!-- 5.资格审查 -->
      <zgsc v-if="item.name === 'zgsc' && projectDetail.apply" :process_index="index" :process="item"
        :current="projectDetail.step" v-show="step_name === item.name" />

      <!-- 6.打印报名表 -->
      <dybmb v-if="item.name === 'dybmb' && projectDetail.apply" :process_index="index" :process="item"
        :current="projectDetail.step" v-show="step_name === item.name" />

      <!-- 7.缴费 -->
      <jf v-if="item.name === 'jf' && projectDetail.apply" :process_index="index" :process="item"
        :current="projectDetail.step" v-show="step_name === item.name" />

      <!-- 8.考前改报 -->
      <kqgb v-if="item.name === 'kqgb' && projectDetail.apply" :process_index="index" :process="item"
        :current="projectDetail.step" v-show="step_name === item.name" />

      <!-- 9.相关教材 -->
      <xgjc v-if="item.name === 'xgjc' && projectDetail.apply" :process_index="index" :process="item"
        :current="projectDetail.step" v-show="step_name === item.name" />

      <!-- 10.打印准考证 -->
      <dyzkz v-if="item.name === 'dyzkz' && projectDetail.apply" :process_index="index" :process="item"
        :current="projectDetail.step" v-show="step_name === item.name" />

      <!-- 11.成绩查询 -->
      <cjcx v-if="item.name === 'cjcx' && projectDetail.apply" :process_index="index" :process="item"
        :current="projectDetail.step" v-show="step_name === item.name" />

      <!-- 12.考后调剂 -->
      <khtj v-if="item.name === 'khtj' && projectDetail.apply" :process_index="index" :process="item"
        :current="projectDetail.step" v-show="step_name === item.name" />
      <!-- 13.缴纳学费 -->

      <xuefei v-if="item.name === 'xuefei' && projectDetail.apply" :process_index="index" :process="item"
        :current="projectDetail.step" v-show="step_name === item.name" />
      <!-- 14.报考完成 -->

      <bkwc v-if="item.name === 'bkwc' && projectDetail.apply" :process_index="index" :process="item"
        :current="projectDetail.step" v-show="step_name === item.name" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useMainStore } from "@/store/piniaStore";
import { erroralert, successalert } from "@/utils/alert";
import kswj from "@/pages/project/steps/kswj.vue";
import kscn from "@/pages/project/steps/kscn.vue";
import bkxx from "@/pages/project/steps/bkxx.vue";
import zgsc from "@/pages/project/steps/zgsc.vue";
import jf from "@/pages/project/steps/jf.vue";
import xgjc from "@/pages/project/steps/xgjc.vue";
import dyzkz from "@/pages/project/steps/dyzkz.vue";
import cjcx from "@/pages/project/steps/cjcx.vue";
import khtj from "@/pages/project/steps/khtj.vue";
import zldj from "@/pages/project/steps/zldj.vue";
import dybmb from "@/pages/project/steps/dybmb.vue";
import kqgb from "@/pages/project/steps/kqgb.vue";
import bkxx2 from "@/pages/project/steps/bkxx2.vue";
import bkwc from "@/pages/project/steps/bkwc.vue";
import xuefei from "@/pages/project/steps/xuefei.vue";
import { reqProjectSavedata, reqProjectDetail } from "@/api";
export default {
  inject: ["reload"],
  components: {
    kswj,
    kscn,
    bkxx,
    zgsc,
    jf,
    kqgb,
    xgjc,
    dyzkz,
    cjcx,
    khtj,
    zldj,
    dybmb,
    khtj,
    dyzkz,
    xgjc,
    kqgb,
    bkxx2,
    bkwc,
    xuefei,
  },
  computed: {
    ...mapState(useMainStore, {
      projectDetail: "getProjectDetail",
      userInfo: "getUserInfo",
      userCertInfo: "getUserCertInfo",
    }),
  },
  created() {
    // this.$parent.reload();
    console.log("刷新");
  },
  mounted() {
    this.getProjectDetail();
    console.log("步骤active的值", Number.isNaN(Number(localStorage.getItem("active"))) ? 0 : parseInt(localStorage.getItem("active"), 10));
  },

  data() {
    return {
      full_step: 0,
      step_name: localStorage.getItem("currentStepName") || "", // Initialize logically to fetch current step content
      active: Number.isNaN(Number(localStorage.getItem("active"))) ? 0 : parseInt(localStorage.getItem("active"), 10),
    };
  },
  methods: {
    ...mapActions(useMainStore, {
      changeProject: "updateProjectDetail",
    }),
    getProjectDetail(targetStepName = null) {
      if(targetStepName) {
        this.step_name = targetStepName; // Temporarily update internal querying parameter
      }
      
      reqProjectDetail({
        project_id: this.$route.query.id,
        step_name: this.step_name,
      }).then((res) => {
        if (res.data.code === 1) {
          // If first load and step_name wasn't explicitly saved/provided, infer the current step from process array based on old active indexing or let backend decide.
          if (!this.step_name && res.data.data.process && res.data.data.process.length > 0) {
              const activeIndexFromStorage = Number.isNaN(Number(localStorage.getItem("active"))) ? 0 : parseInt(localStorage.getItem("active"), 10);
              let fallbackIndex = activeIndexFromStorage < res.data.data.process.length ? activeIndexFromStorage : 0;
              this.step_name = res.data.data.process[fallbackIndex].name;
              localStorage.setItem("currentStepName", this.step_name);
              // fetch again since we now know the name we actually want to render
              return this.getProjectDetail(this.step_name);
          }
          this.changeProject(res.data.data);
          
          // Legacy code migration: Keep `active` accurate for the visual el-steps bar
          let newActiveIndex = res.data.data.process.findIndex(item => item.name === this.step_name);
          if(newActiveIndex !== -1) {
             this.active = newActiveIndex;
             localStorage.setItem("active", this.active);
          }
        }
      });
      if (!this.projectDetail.id) {
      }
    },
    jumpToProcess(step_index, item) {
      console.log("流程数据", item);
      if (item.enable == 0) {
        return false;
      }
      if (step_index <= this.projectDetail.current_step) {
        localStorage.setItem("active", step_index);
        localStorage.setItem("currentStepName", item.name);
        
        // Let the reload trigger the fetch safely inside mounted()
        this.step_name = item.name;
        this.reload();
      }
    },
    next() {
      if (this.active < this.projectDetail.next_step) {
        console.log(this.active, this.projectDetail.process.length);
        this.active = this.active + 1;
        
        // Lookup the name of the next step
        const nextProcessItem = this.projectDetail.process[this.active];
        if (nextProcessItem) {
           this.step_name = nextProcessItem.name;
           localStorage.setItem("currentStepName", this.step_name);
        }
        localStorage.setItem("active", this.active);
        
        //如果active大于current_step说明报考进度在往前走，需要保存入库
        if (this.active > this.projectDetail.current_step) {
          reqProjectSavedata({
            current_step: this.active,
            project_id: this.projectDetail.project_info.id,
          }).then((res) => {
            if (res.data.code === 1) {
              // Instead of calling detail and reloading, just reload because mounted() handles reading detail.
              this.reload();
              // this.$message.success(res.data.msg);
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          // Progress isn't moving forward structurally (just navigating interface), but we still need the content payload for the new page.
          this.reload();
        }
      } else {
        this.$message.error("无法进入下一流程");
        // this.active = 0;
      }
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    routeHop(url) {
      this.$router.push(url);
    },
    reqProjectSavedata(data) {
      return reqProjectSavedata(data);
    },
  },
};
</script>

<style scoped>
.warm-tip {
  width: 80%;
  margin-left: 10%;
  font-size: 16px;
  color: rgb(104, 99, 99);
  margin-top: 30px;
}

.title-apply-position {
  font-size: 16px;
  color: rgb(8, 8, 8);
  margin: 10px;
}

.inner-box {
  margin: 0px 20px;
}

.next-step:hover {
  transform: scale(1.1);
  cursor: pointer;
}

.next-step {
  color: #b8000d;
  border: #b8000d 1px solid;
  width: 60px;
  height: 30px;
  border-radius: 3px;
  margin-left: 30%;
  background-color: white;
  margin-top: 30px;
}

.pay-box {
  width: 90%;
}

.data {
  color: rgb(110, 105, 105);
  font-size: 14px;
  margin-top: 20px;
}

.two-line {
  height: 30px;
  border-radius: 3px;
  background-color: rgb(248, 246, 246);
  font-size: 14px;
  color: rgb(126, 121, 121);
  margin-top: 20px;
  width: 90%;
}

/* .positions {
  width: 250px;
  height: 30px;
  border: rgb(231, 225, 225) 1px solid;
  margin: 40px 0px 0px 30px;
  border-radius: 3px;
  padding-left: 5px;
} */
.position-text {
  font-size: 14px;
  color: rgb(121, 116, 116);
  margin-left: 40px;
  margin-top: 30px;
}

.position {
  width: 150px;
  height: 30px;
  border: rgb(231, 225, 225) 1px solid;
  margin: 25px 0px 0px 30px;
  border-radius: 3px;
  padding-left: 5px;
}

/* .wram-tip {
  font-size: 15px;
  margin-left: 40px;
  color: rgb(126, 121, 121);
} */
.title {
  font-size: 17px;
  padding-top: 10px;
  margin-left: 5px;
}

.sill {
  width: 100%;
  height: 1px;
  background-color: rgb(231, 225, 225);
  margin-top: 10px;
}

.one-box {
  width: 80%;
  height: 200px;
  /* background-color: turquoise; */
  margin-top: 30px;
  border: rgb(231, 225, 225) 1px solid;
  border-radius: 4px;
}

.two-box {
  width: 80%;
  height: 150px;
  /* background-color: rgb(176, 204, 100); */
  margin-top: 40px;
  border: rgb(231, 225, 225) 1px solid;
  border-radius: 4px;
}

/* .three-box {
  width: 80%;
  height: 300px;
 
  margin-top: 40px;
  border: rgb(231, 225, 225) 1px solid;
  border-radius: 4px;
} */
.submit:hover {
  transform: scale(1.1);
}

.submit {
  width: 100px;
  height: 30px;
  margin-top: 40px;
  background-color: white;
  border: rgb(204, 198, 198) 1px solid;
  border-radius: 3px;
  color: rgb(126, 121, 121);
}

.score-line {
  margin-top: 20px;
}

.big-box {
  width: 80%;
  margin-left: 10%;
}

.item-text {
  font-size: 16px;
  margin: 20px 10%;
  color: rgb(56, 55, 55);
}

.agree-sign-next {
  margin-top: 40px;
}

.agree-pro {
  margin-top: 11px;
}

.next-step:hover {
  transform: scale(1.1);
  cursor: pointer;
}

.s-sign {
  font-size: 14px;
  color: rgb(105, 103, 103);
  font-weight: 500;
  margin-top: 8px;
  margin-left: 40px;
}

.sign {
  width: 100px;
  height: 3px;
  background-color: rgb(161, 155, 155);
  margin-top: 30px;
  margin-left: 10px;
}

.profile-content {
  margin-top: 20px;
  width: 83%;
  padding: 40px 50px 80px;
  background: white !important;
  border-radius: 5px;
  box-sizing: border-box;
}

.testprofile {
  width: 100%;
}

.el-steps--simple {
  width: 83%;
  margin: 0 auto;
  padding: 20px 50px;
  border-radius: 4px;
  background: #ffff !important;
  box-sizing: border-box;
}

.my-photo {
  font-size: 25px;
  color: #c2c1c1;
}

.my-headimg {
  width: 160px;
  height: 150px;
}

.next-step:hover {
  transform: scale(1.1);
  cursor: pointer;
}

.next-step {
  color: #b8000d;
  border: #b8000d 1px solid;
  width: 60px;
  height: 30px;
  border-radius: 3px;
  margin-left: 30px;
  background-color: white;
  margin-top: 5px;
}

.data {
  color: rgb(110, 105, 105);
  font-size: 14px;
  margin-top: 20px;
}

.two-line {
  width: 96%;
  height: 30px;
  border-radius: 3px;
  margin-left: 2%;
  background-color: rgb(248, 246, 246);
  font-size: 14px;
  color: rgb(126, 121, 121);
  margin-top: 20px;
}

.positions {
  width: 250px;
  height: 30px;
  border: rgb(231, 225, 225) 1px solid;
  margin: 40px 0px 0px 30px;
  border-radius: 3px;
  padding-left: 5px;
}

.position-text {
  font-size: 14px;
  color: rgb(36, 34, 34);
  margin-left: 40px;
  margin-top: 30px;
}

.position {
  width: 150px;
  height: 30px;
  border: rgb(231, 225, 225) 1px solid;
  margin: 25px 0px 0px 30px;
  border-radius: 3px;
  padding-left: 5px;
}

.wram-tip {
  font-size: 15px;
  margin-left: 40px;
  color: rgb(126, 121, 121);
}

.title {
  font-size: 17px;
  padding-top: 10px;
  margin-left: 5px;
}

/* .sill {
  width: 100%;
  height: 1px;
  background-color: rgb(231, 225, 225);
  margin-top: 10px;
} */
/* .one-box {
  width: 80%;
  height: 200px;

  margin-top: 40px;
  border: rgb(231, 225, 225) 1px solid;
  border-radius: 4px;
} */
.two-box {
  width: 80%;
  height: 150px;
  /* background-color: rgb(176, 204, 100); */
  margin-top: 40px;
  border: rgb(231, 225, 225) 1px solid;
  border-radius: 4px;
}

/* .three-box {
  width: 80%;
  height: 150px;
 
  margin-top: 40px;
  border: rgb(231, 225, 225) 1px solid;
  border-radius: 4px;
}
.submit:hover {
  transform: scale(1.1);
} */
.three-box {
  width: 80%;
  height: 300px;
  /* background-color: rgb(149, 121, 226); */
  margin-top: 40px;
  border: rgb(231, 225, 225) 1px solid;
  border-radius: 4px;
}

.submit:hover {
  transform: scale(1.1);
}

.submit {
  width: 100px;
  height: 30px;
  margin-top: 40px;
  background-color: white;
  border: rgb(204, 198, 198) 1px solid;
  border-radius: 3px;
  color: rgb(126, 121, 121);
}

.sign-name {
  width: 200px;
  border: none;
  padding: 0 10px;
}

.el-step__title.is-success {
  color: #b8000d;
}

.el-step__head.is-success {
  color: #b8000d;
  border-color: #b8000d;
}

.el-step__icon.is-text {
  border-radius: 50%;
  border: 1px solid;
  border-color: inherit;
}
</style>
